(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bls-article-v2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initArticle() {
      var articleRoot = document.querySelector('.bls-article-v2');
      if (!articleRoot || articleRoot.dataset.blsInitialized === 'true') return;
      articleRoot.dataset.blsInitialized = 'true';

      var content = articleRoot.querySelector('#blsBlogContent');
      var desktopToc = articleRoot.querySelector('#blsBlogToc');
      var mobileToc = articleRoot.querySelector('#blsBlogMobileToc');
      var mobileTocWrap = articleRoot.querySelector('#blsBlogMobileTocWrap');

      if (!content || !desktopToc || !mobileToc) return;

      content.querySelectorAll('table').forEach(function (table) {
        if (table.parentElement && table.parentElement.classList.contains('bls-article-v2__table-scroll')) return;
        var wrapper = document.createElement('div');
        wrapper.className = 'bls-article-v2__table-scroll';
        wrapper.setAttribute('role', 'region');
        wrapper.setAttribute('aria-label', articleRoot.dataset.tableLabel || 'Scrollable article table');
        wrapper.setAttribute('tabindex', '0');
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
      });

      var headings = Array.prototype.slice.call(content.querySelectorAll('h2')).filter(function (heading) {
        return !heading.closest('.bl-blog-toc') && !heading.closest('.bl-blog-cta');
      });

      function createTocItem(heading) {
        var item = document.createElement('li');
        var link = document.createElement('a');
        link.href = '#' + heading.id;
        link.textContent = heading.textContent.trim();
        item.appendChild(link);
        return item;
      }

      headings.forEach(function (heading, index) {
        var label = heading.textContent.trim();
        if (!label) return;
        if (!heading.id) heading.id = 'bls-article-section-' + (index + 1);
        desktopToc.appendChild(createTocItem(heading));
        mobileToc.appendChild(createTocItem(heading));
      });

      if (!desktopToc.children.length) {
        if (desktopToc.parentElement) desktopToc.parentElement.hidden = true;
        if (mobileTocWrap) mobileTocWrap.hidden = true;
        return;
      }

      mobileToc.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', function () {
          if (mobileTocWrap) mobileTocWrap.open = false;
        });
      });

      if ('IntersectionObserver' in window) {
        var desktopLinks = Array.prototype.slice.call(desktopToc.querySelectorAll('a'));
        var linkById = {};

        desktopLinks.forEach(function (link) {
          linkById[link.getAttribute('href').slice(1)] = link;
        });

        var observer = new IntersectionObserver(function (entries) {
          var visible = entries
            .filter(function (entry) { return entry.isIntersecting; })
            .sort(function (a, b) { return a.boundingClientRect.top - b.boundingClientRect.top; });

          if (!visible.length) return;

          desktopLinks.forEach(function (link) {
            link.removeAttribute('aria-current');
          });

          var activeLink = linkById[visible[0].target.id];
          if (activeLink) activeLink.setAttribute('aria-current', 'true');
        }, {
          rootMargin: '-18% 0px -68% 0px',
          threshold: [0, 1]
        });

        headings.forEach(function (heading) {
          if (heading.id) observer.observe(heading);
        });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initArticle, { once: true });
    } else {
      initArticle();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bls-customization-content"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initialize(root) {
    if (!root || root.dataset.blcInitialized === 'true') return;
    root.dataset.blcInitialized = 'true';

  // Native scroll-snap supports swiping and manual arrows without a library.
  // One 5.5s timer rotates only galleries in view, never while a visitor interacts.
  var allCarousels = [];
  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  var motionOff = !!(reducedMotion && reducedMotion.matches);
  var galleryObserver = null;
  if ('IntersectionObserver' in window) {
    galleryObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.target.__blcCarouselState) {
          entry.target.__blcCarouselState.visible = entry.isIntersecting;
        }
      });
    }, {threshold:0.25});
  }
  root.querySelectorAll('[data-blc-carousel]').forEach(function (gallery) {
    var track = gallery.querySelector('.blc-gallery-track');
    var slides = Array.prototype.slice.call(gallery.querySelectorAll('.blc-gallery-slide'));
    var prev = gallery.querySelector('[data-blc-prev]');
    var next = gallery.querySelector('[data-blc-next]');
    var current = gallery.querySelector('[data-blc-current]');
    var progress = gallery.querySelector('[data-blc-progress]');
    if (!track || slides.length < 2 || !prev || !next || !current || !progress) return;

    var state = {visible:!galleryObserver, paused:motionOff, hovered:false, focused:false, holding:false, interactionUntil:0};
    gallery.__blcCarouselState = state;
    var active = 0;
    var ticking = false;
    function syncUI() {
      current.textContent = String(active + 1).padStart(2,'0');
      progress.style.width = ((active + 1) * 100 / slides.length) + '%';
      prev.disabled = active === 0;
      next.disabled = active === slides.length - 1;
    }
    function goTo(index, wrap) {
      index = Math.max(0,Math.min(slides.length - 1,index));
      active = index;
      syncUI();
      track.scrollTo({left:slides[index].offsetLeft - track.offsetLeft,
        behavior:(motionOff || wrap) ? 'auto' : 'smooth'});
    }
    function delayAuto() {state.interactionUntil = Date.now() + 11000;}
    prev.addEventListener('click',function () {delayAuto();goTo(active - 1,false);});
    next.addEventListener('click',function () {delayAuto();goTo(active + 1,false);});
    track.addEventListener('scroll',function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        active = Math.max(0,Math.min(slides.length - 1, Math.round(track.scrollLeft/Math.max(1,track.clientWidth))));
        syncUI();
        ticking = false;
      });
    },{passive:true});
    track.addEventListener('keydown',function (event) {
      if (event.key === 'ArrowRight') {event.preventDefault();delayAuto();goTo(active + 1,false);}
      if (event.key === 'ArrowLeft') {event.preventDefault();delayAuto();goTo(active - 1,false);}
    });
    track.addEventListener('pointerdown',function () {state.holding=true;delayAuto();},{passive:true});
    track.addEventListener('pointerup',function () {state.holding=false;delayAuto();},{passive:true});
    track.addEventListener('pointercancel',function () {state.holding=false;delayAuto();},{passive:true});
    gallery.addEventListener('mouseenter',function () {state.hovered=true;});
    gallery.addEventListener('mouseleave',function () {state.hovered=false;});
    gallery.addEventListener('focusin',function () {state.focused=true;});
    gallery.addEventListener('focusout',function (event) {
      if (!event.relatedTarget || !gallery.contains(event.relatedTarget)) state.focused=false;
    });
    if (galleryObserver) galleryObserver.observe(gallery);
    syncUI();
    allCarousels.push({state:state,slides:slides,advance:function () {
      var nextIndex=(active + 1) % slides.length;
      goTo(nextIndex,nextIndex===0);
    }});
  });
  if (!motionOff && allCarousels.length) {
    var autoplayTimer = window.setInterval(function () {
      if (document.hidden || !root.isConnected) {
        if (!root.isConnected) window.clearInterval(autoplayTimer);
        return;
      }
      allCarousels.forEach(function (item) {
        var state=item.state;
        if (!state.visible || state.paused || state.hovered || state.focused || state.holding || Date.now()<state.interactionUntil) return;
        item.advance();
      });
    },5500);
  }

  // Keep a uniform portrait cover; load video in place only after an intentional click.
  root.querySelectorAll('.blc-v9-video').forEach(function (item) {
    var poster = item.querySelector('.blc-v9-video-poster');
    var frame = item.querySelector('.blc-v9-video-screen');
    var id = item.getAttribute('data-video-id');
    if (!poster || !frame || !id || !/^[A-Za-z0-9_-]{11}$/.test(id)) return;
    poster.addEventListener('click',function () {
      if (frame.querySelector('iframe')) return;
      if (item.getAttribute('data-landscape') === 'true') frame.classList.add('is-landscape');
      var iframe=document.createElement('iframe');
      iframe.title='Factory production video';
      iframe.src='https://www.youtube-nocookie.com/embed/'+id+'?autoplay=1&playsinline=1&rel=0';
      iframe.allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      iframe.allowFullscreen=true;
      iframe.referrerPolicy='strict-origin-when-cross-origin';
      frame.replaceChildren(iframe);
    });
  });

  // Subtle entrance effects, with no flash/hiding for reduced motion or JS failure.
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var targets = root.querySelectorAll('.blc-value-intro, .blc-value-photo, .blc-value-item, .blc-value-image-strip, .blc-cap-head, .blc-cap-item, .blc-feature-head, .blc-feature-stats, .blc-feature-storyboard, .blc-v9-case, .blc-v9-delivery-header, .blc-v9-delivery-core, .blc-v9-delivery-time, .blc-v9-delivery-support, .blc-faq-intro, .blc-faq-list, .blc-final-content');
    var io = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {threshold:0.06, rootMargin:'0px 0px 40px 0px'});
    targets.forEach(function (node) { node.setAttribute('data-blc-reveal', ''); io.observe(node); });
    root.classList.add('blc-motion-ready');
  }
  }

  document.querySelectorAll('.blc-page').forEach(initialize);
  document.addEventListener('shopify:section:load', function (event) {
    if (event && event.target && event.target.querySelectorAll) {
      event.target.querySelectorAll('.blc-page').forEach(initialize);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bls-hotel-lobby-guide"] && !Shopify.designMode) return;
  try {
    
  class BlsHotelLobbyDisclosure extends HTMLElement {
    connectedCallback() {
      this.disclosureDetails = this.querySelector('details');
      this.disclosureSummary = this.disclosureDetails?.querySelector('summary');
      if (!this.disclosureDetails || !this.disclosureSummary) return;
      this.syncExpandedState();
      this.disclosureDetails.addEventListener('toggle', this.syncExpandedState);
    }

    disconnectedCallback() {
      this.disclosureDetails?.removeEventListener('toggle', this.syncExpandedState);
    }

    syncExpandedState = () => {
      this.disclosureSummary?.setAttribute('aria-expanded', this.disclosureDetails.open ? 'true' : 'false');
    };
  }

  if (!customElements.get('bls-hotel-lobby-disclosure')) {
    customElements.define('bls-hotel-lobby-disclosure', BlsHotelLobbyDisclosure);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bls-lighting-size-calculator"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-bls-size-calculator]');

    roots.forEach((root) => {
      if (root.dataset.calculatorReady === 'true') return;
      root.dataset.calculatorReady = 'true';

      const form = root.querySelector('[data-calculator-form]');
      const results = root.querySelector('[data-calculator-results]');
      const copyNode = root.querySelector('[data-calculator-copy]');
      if (!form || !results || !copyNode) return;

      const copy = JSON.parse(copyNode.textContent);
      const roomType = form.querySelector('[data-room-type]');
      const shape = form.querySelector('[data-fixture-shape]');
      const referenceFields = form.querySelectorAll('[data-reference-field]');
      const countField = form.querySelector('[data-count-field]');
      const referenceHelp = form.querySelector('[data-reference-help]');
      const errorBox = form.querySelector('[data-form-error]');
      const roomUnits = form.querySelectorAll('[data-room-unit]');
      const referenceUnits = form.querySelectorAll('[data-reference-unit]');
      const referenceLengthLabel = form.querySelector('[data-reference-length-label]');
      const referenceWidthLabel = form.querySelector('[data-reference-width-label]');
      const collectionLink = results.querySelector('[data-collection-link]');
      const projectCta = results.querySelector('[data-project-cta]');

      const collectionMap = {
        dining: '/collections/dining-room',
        kitchen: '/collections/kitchen',
        living: '/collections/living-room',
        bedroom: '/collections/bedroom',
        foyer: '/collections/foyer-lighting',
        staircase: '/collections/staircase-chandeliers',
        high_ceiling: '/collections/high-ceiling-chandelier'
      };

      const lumenMap = {
        dining: [20, 30],
        kitchen: [30, 40],
        living: [10, 20],
        bedroom: [10, 20],
        foyer: [10, 15],
        staircase: [10, 15],
        high_ceiling: [15, 25]
      };

      const selectedUnit = () => form.querySelector('input[name="unit_system"]:checked').value;
      const valueOf = (name) => Number.parseFloat(form.elements[name].value);
      const isFinitePositive = (value) => Number.isFinite(value) && value > 0;
      const toFeet = (value) => selectedUnit() === 'metric' ? value * 3.28084 : value;
      const toInches = (value) => selectedUnit() === 'metric' ? value / 2.54 : value;
      const round = (value, increment = 1) => Math.round(value / increment) * increment;
      const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

      const dualRange = (minInches, maxInches) => {
        const min = Math.max(0, round(minInches));
        const max = Math.max(min, round(maxInches));
        const minCm = round(min * 2.54);
        const maxCm = round(max * 2.54);
        return `${min}–${max} in / ${minCm}–${maxCm} cm`;
      };

      const singleDual = (inches) => {
        const value = Math.max(0, round(inches));
        return `${value} in / ${round(value * 2.54)} cm`;
      };

      const updateReferenceLabels = () => {
        const type = roomType.value;
        const isImperial = selectedUnit() === 'imperial';
        roomUnits.forEach((node) => { node.textContent = isImperial ? 'ft' : 'm'; });
        referenceUnits.forEach((node) => { node.textContent = isImperial ? 'in' : 'cm'; });

        if (type === 'dining') {
          referenceLengthLabel.textContent = copy.table_length;
          referenceWidthLabel.textContent = copy.table_width;
          referenceHelp.textContent = copy.reference_recommended;
        } else if (type === 'kitchen') {
          referenceLengthLabel.textContent = copy.island_length;
          referenceWidthLabel.textContent = copy.island_width;
          referenceHelp.textContent = copy.reference_recommended;
        } else if (type === 'staircase') {
          referenceLengthLabel.textContent = copy.opening_length;
          referenceWidthLabel.textContent = copy.opening_width;
          referenceHelp.textContent = copy.reference_recommended;
        } else {
          referenceLengthLabel.textContent = copy.reference_length;
          referenceWidthLabel.textContent = copy.reference_width;
          referenceHelp.textContent = copy.reference_optional;
        }

        const showCount = type === 'kitchen' || type === 'dining';
        countField.hidden = !showCount;
        referenceFields.forEach((field) => { field.hidden = false; });
      };

      const clearErrors = () => {
        errorBox.hidden = true;
        errorBox.textContent = '';
        form.querySelectorAll('[aria-invalid="true"]').forEach((input) => input.removeAttribute('aria-invalid'));
      };

      const validate = () => {
        clearErrors();
        const requiredNames = ['room_length', 'room_width', 'ceiling_height'];
        let firstInvalid = null;

        requiredNames.forEach((name) => {
          const input = form.elements[name];
          if (!isFinitePositive(Number.parseFloat(input.value))) {
            input.setAttribute('aria-invalid', 'true');
            firstInvalid ||= input;
          }
        });

        if (firstInvalid) {
          errorBox.textContent = copy.required;
          errorBox.hidden = false;
          firstInvalid.focus();
          return false;
        }

        const ceilingFeet = toFeet(valueOf('ceiling_height'));
        if (ceilingFeet < 6 || ceilingFeet > 80) {
          const input = form.elements.ceiling_height;
          input.setAttribute('aria-invalid', 'true');
          errorBox.textContent = copy.invalid;
          errorBox.hidden = false;
          input.focus();
          return false;
        }

        return true;
      };

      const calculate = () => {
        const type = roomType.value;
        const fixtureShape = shape.value;
        const roomLengthFt = toFeet(valueOf('room_length'));
        const roomWidthFt = toFeet(valueOf('room_width'));
        const ceilingFt = toFeet(valueOf('ceiling_height'));
        const referenceLengthRaw = valueOf('reference_length');
        const referenceWidthRaw = valueOf('reference_width');
        const referenceLengthIn = isFinitePositive(referenceLengthRaw) ? toInches(referenceLengthRaw) : null;
        const referenceWidthIn = isFinitePositive(referenceWidthRaw) ? toInches(referenceWidthRaw) : null;
        const fixtureCount = Number.parseInt(form.elements.fixture_count.value, 10) || 1;
        const area = roomLengthFt * roomWidthFt;

        const roomDiameter = (roomLengthFt + roomWidthFt);
        let diameterMin = roomDiameter * 0.9;
        let diameterMax = roomDiameter * 1.1;
        let lengthMin = diameterMin * 1.2;
        let lengthMax = diameterMax * 1.6;
        const notes = [copy.note_room];

        if (type === 'dining' && referenceWidthIn) {
          diameterMin = referenceWidthIn * 0.5;
          diameterMax = Math.min(referenceWidthIn * 0.67, Math.max(referenceWidthIn - 12, diameterMin));
          notes.push(copy.note_surface);
        }

        if (type === 'kitchen' && referenceWidthIn && fixtureShape !== 'linear') {
          diameterMin = clamp(referenceWidthIn * 0.45, 6, 36);
          diameterMax = clamp(referenceWidthIn * 0.6, diameterMin, Math.max(referenceWidthIn - 12, diameterMin));
          notes.push(copy.note_surface);
        }

        if (type === 'staircase' && referenceWidthIn) {
          diameterMax = Math.min(diameterMax, referenceWidthIn * 0.75);
          diameterMin = Math.min(diameterMin, diameterMax * 0.82);
          notes.push(copy.note_staircase);
        }

        if (referenceLengthIn && fixtureShape === 'linear') {
          lengthMin = referenceLengthIn * 0.5;
          lengthMax = referenceLengthIn * 0.67;
          notes.push(copy.note_linear);
        }

        if ((type === 'dining' || type === 'kitchen') && fixtureCount > 1 && referenceLengthIn) {
          const centerSpacing = referenceLengthIn / (fixtureCount + 1);
          notes.push(copy.note_multiple.replace('__COUNT__', fixtureCount).replace('__SPACING__', singleDual(centerSpacing)));
        }

        const bodyHeightMin = ceilingFt * 2.5;
        const bodyHeightMax = ceilingFt * 3;
        const extraCeilingFeet = Math.max(0, ceilingFt - 8);
        const surfaceClearanceMin = 30 + (extraCeilingFeet * 3);
        const surfaceClearanceMax = 36 + (extraCeilingFeet * 3);
        const floorClearanceFeet = ceilingFt >= 12 ? 8 : 7;
        const maxOverallDrop = Math.max(0, (ceilingFt - floorClearanceFeet) * 12);

        const lumenRate = lumenMap[type];
        const lumenMin = round(area * lumenRate[0], 100);
        const lumenMax = round(area * lumenRate[1], 100);

        if (ceilingFt < 8) notes.push(copy.note_low_ceiling);
        if (ceilingFt >= 14) notes.push(copy.note_high_ceiling);
        if (diameterMax >= 60 || lengthMax >= 72) notes.push(copy.note_large_fixture);
        notes.push(copy.note_lumens);

        results.querySelector('[data-result-summary]').textContent = copy.summary.replace('__ROOM__', copy.room_names[type]);
        results.querySelector('[data-result-diameter]').textContent = dualRange(diameterMin, diameterMax);
        results.querySelector('[data-result-height]').textContent = dualRange(bodyHeightMin, bodyHeightMax);
        results.querySelector('[data-result-lumens]').textContent = `${lumenMin.toLocaleString()}–${lumenMax.toLocaleString()} lm`;

        const lengthCard = results.querySelector('[data-length-card]');
        lengthCard.hidden = fixtureShape !== 'linear';
        if (!lengthCard.hidden) results.querySelector('[data-result-length]').textContent = dualRange(lengthMin, lengthMax);

        const hangingResult = results.querySelector('[data-result-hanging]');
        const hangingHelp = results.querySelector('[data-hanging-help]');
        if (type === 'dining' || type === 'kitchen') {
          hangingResult.textContent = dualRange(surfaceClearanceMin, surfaceClearanceMax);
          hangingHelp.textContent = copy.above_surface;
        } else {
          hangingResult.textContent = `${floorClearanceFeet} ft / ${round(floorClearanceFeet * 30.48)} cm`;
          hangingHelp.textContent = `${copy.floor_clearance} ${singleDual(maxOverallDrop)}`;
        }

        const noteList = results.querySelector('[data-result-notes]');
        noteList.replaceChildren(...notes.map((note) => {
          const item = document.createElement('li');
          item.textContent = note;
          return item;
        }));

        collectionLink.href = collectionMap[type];
        projectCta.href = `/pages/customization?source=size-calculator&room=${encodeURIComponent(type)}`;
        results.hidden = false;

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'bls_size_calculator_completed',
          room_type: type,
          fixture_shape: fixtureShape,
          unit_system: selectedUnit(),
          recommended_diameter_in: round((diameterMin + diameterMax) / 2)
        });

        if (window.matchMedia('(max-width: 980px)').matches) {
          results.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      };

      form.addEventListener('submit', (event) => {
        event.preventDefault();
        if (validate()) calculate();
      });

      form.addEventListener('change', (event) => {
        if (event.target.name === 'unit_system' || event.target === roomType) updateReferenceLabels();
      });

      root.querySelector('[data-copy-results]').addEventListener('click', async (event) => {
        const button = event.currentTarget;
        const original = button.textContent;
        const text = results.innerText;
        try {
          await navigator.clipboard.writeText(text);
          button.textContent = copy.copied;
        } catch (_error) {
          button.textContent = copy.copy_failed;
        }
        window.setTimeout(() => { button.textContent = original; }, 1800);
      });

      projectCta.addEventListener('click', () => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'bls_size_calculator_quote_click', room_type: roomType.value });
      });

      updateReferenceLabels();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bls-product-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function prepareDescriptionLayout(root) {
      var scope = root || document;

      scope.querySelectorAll('[data-bls-product-description-layout]').forEach(function (layout) {
        if (layout.dataset.blsDescriptionLayoutReady === 'true') return;

        var copy = layout.querySelector('[data-bls-product-description-copy]');
        var continuation = layout.querySelector('[data-bls-product-description-continuation]');

        if (!copy || !continuation) {
          layout.dataset.blsDescriptionLayoutReady = 'true';
          return;
        }

        var directChildren = Array.prototype.slice.call(copy.children);
        var boundary = directChildren.find(function (element) {
          return element.matches('.bl-highlight');
        });

        if (!boundary) {
          var headingIndex = directChildren.findIndex(function (element) {
            if (!element.matches('h1, h2, h3, h4, h5, h6')) return false;

            return /^(highlights|key features)\s*:?\s*$/i.test(element.textContent.trim());
          });

          if (headingIndex !== -1) {
            boundary = directChildren.slice(headingIndex + 1).find(function (element) {
              return element.matches('a.bl-img-link, figure, .bl-grid, .bl-card, .bl-two-img');
            });
          }
        }

        if (boundary) {
          var node = boundary;

          while (node) {
            var nextNode = node.nextSibling;
            continuation.appendChild(node);
            node = nextNode;
          }

          if (continuation.childNodes.length > 0) {
            continuation.hidden = false;
          }
        }

        layout.dataset.blsDescriptionLayoutReady = 'true';
      });
    }

    function enhanceFaqAccordions(root) {
      var scope = root || document;

      scope.querySelectorAll('[data-bls-product-faq-accordion]').forEach(function (accordion) {
        if (accordion.dataset.blsProductFaqReady === 'true') return;

        var richText = accordion.querySelector('.metafield-rich_text_field');
        if (richText) {
          var questionHeadings = Array.prototype.slice.call(richText.children).filter(function (element) {
            return element.tagName === 'H4';
          });

          questionHeadings.forEach(function (heading) {
            if (!heading.parentNode) return;

            var nextNode = heading.nextSibling;
            var details = document.createElement('details');
            var summary = document.createElement('summary');
            var answer = document.createElement('div');

            details.className = 'bls-product-faq-accordion__item';
            summary.className = 'bls-product-faq-accordion__question';
            answer.className = 'bls-product-faq-accordion__answer';

            while (heading.firstChild) {
              summary.appendChild(heading.firstChild);
            }

            heading.parentNode.insertBefore(details, heading);
            heading.remove();
            details.appendChild(summary);

            while (nextNode && !(nextNode.nodeType === 1 && nextNode.tagName === 'H4')) {
              var followingNode = nextNode.nextSibling;
              answer.appendChild(nextNode);
              nextNode = followingNode;
            }

            details.appendChild(answer);
          });
        }

        accordion.dataset.blsProductFaqReady = 'true';
      });
    }

    function initProductTabs(root) {
      if (!root || root.dataset.blsProductTabsReady === 'true') return;
      root.dataset.blsProductTabsReady = 'true';

      var component = root.querySelector('[data-bls-product-tabs]');
      if (!component) return;

      var tabs = Array.prototype.slice.call(component.querySelectorAll('[data-bls-product-tab]'));
      var panels = Array.prototype.slice.call(component.querySelectorAll('[data-bls-product-panel]'));
      var mobileQuery = window.matchMedia('(max-width: 749px)');

      /*
       * Desktop:
       * Standard tab behavior — only one panel open.
       */
      function activateDesktopTab(tab) {
        var target = tab.getAttribute('data-bls-product-tab');

        tabs.forEach(function (item) {
          var isActive = item === tab;

          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-selected', isActive ? 'true' : 'false');
          item.setAttribute('aria-expanded', isActive ? 'true' : 'false');
          item.setAttribute('tabindex', isActive ? '0' : '-1');
        });

        panels.forEach(function (panel) {
          var isActive =
            panel.getAttribute('data-bls-product-panel') === target;

          panel.classList.toggle('is-active', isActive);
          panel.hidden = !isActive;
        });
      }

      /*
       * Mobile:
       * Accordion behavior — each section is independent.
       * Opening FAQ / Customization / Buying Guide does NOT
       * close Product Details or another open section.
       */
      function toggleMobileTab(tab) {
        var target = tab.getAttribute('data-bls-product-tab');
        var willOpen = !tab.classList.contains('is-active');

        tab.classList.toggle('is-active', willOpen);
        tab.setAttribute('aria-selected', willOpen ? 'true' : 'false');
        tab.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        tab.setAttribute('tabindex', '0');

        panels.forEach(function (panel) {
          if (panel.getAttribute('data-bls-product-panel') !== target) return;

          panel.classList.toggle('is-active', willOpen);
          panel.hidden = !willOpen;
        });
      }

      /*
       * Used only when mobile has no open section.
       */
      function openMobileTab(tab) {
        if (!tab) return;

        var target = tab.getAttribute('data-bls-product-tab');

        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');
        tab.setAttribute('aria-expanded', 'true');
        tab.setAttribute('tabindex', '0');

        panels.forEach(function (panel) {
          if (panel.getAttribute('data-bls-product-panel') !== target) return;

          panel.classList.add('is-active');
          panel.hidden = false;
        });
      }

      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () {
          if (mobileQuery.matches) {
            toggleMobileTab(tab);
          } else {
            activateDesktopTab(tab);
          }
        });

        tab.addEventListener('keydown', function (event) {
          if (mobileQuery.matches) return;

          if (
            event.key !== 'ArrowRight' &&
            event.key !== 'ArrowLeft' &&
            event.key !== 'Home' &&
            event.key !== 'End'
          ) {
            return;
          }

          event.preventDefault();

          var nextIndex = index;

          if (event.key === 'ArrowRight') {
            nextIndex = (index + 1) % tabs.length;
          }

          if (event.key === 'ArrowLeft') {
            nextIndex = (index - 1 + tabs.length) % tabs.length;
          }

          if (event.key === 'Home') {
            nextIndex = 0;
          }

          if (event.key === 'End') {
            nextIndex = tabs.length - 1;
          }

          activateDesktopTab(tabs[nextIndex]);
          tabs[nextIndex].focus();
        });
      });

      /*
       * Initial mobile state:
       * Keep the Liquid-defined active section.
       * Product Details remains open by default.
       */
      if (mobileQuery.matches) {
        tabs.forEach(function (tab) {
          tab.setAttribute('tabindex', '0');
        });

        if (
          !component.querySelector('[data-bls-product-tab].is-active') &&
          tabs[0]
        ) {
          openMobileTab(tabs[0]);
        }
      }

      /*
       * Breakpoint changes.
       *
       * Mobile:
       * Preserve any open panels and allow multiple panels.
       *
       * Desktop:
       * Convert the multi-open accordion back to one normal tab.
       * The first currently open tab is retained.
       */
      mobileQuery.addEventListener('change', function (event) {
        if (event.matches) {
          tabs.forEach(function (tab) {
            tab.setAttribute('tabindex', '0');
          });

          if (
            !component.querySelector('[data-bls-product-tab].is-active') &&
            tabs[0]
          ) {
            openMobileTab(tabs[0]);
          }

          return;
        }

        var firstOpenTab =
          component.querySelector('[data-bls-product-tab].is-active') ||
          tabs[0];

        if (firstOpenTab) {
          activateDesktopTab(firstOpenTab);
        }
      });
    }


    function initAllProductTabs(container) {
      var scope = container || document;
      prepareDescriptionLayout(scope);
      enhanceFaqAccordions(scope);
      scope.querySelectorAll('[data-bls-product-tabs-section]').forEach(initProductTabs);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAllProductTabs(document);
      });
    } else {
      initAllProductTabs(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAllProductTabs(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smart-related-products"] && !Shopify.designMode) return;
  try {
    
  class ProductMetafieldRecommendations extends HTMLElement {
    connectedCallback() {
      if (!this.dataset.url || this.querySelector('[data-recommendations-ready]')) return;

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const section = html.querySelector('product-metafield-recommendations');

          if (section && section.innerHTML.trim()) {
            this.innerHTML = section.innerHTML;
          }
        });
    }
  }

  if (!customElements.get('product-metafield-recommendations')) {
    customElements.define('product-metafield-recommendations', ProductMetafieldRecommendations);
  }

  } catch(e) { console.error(e); }
})();
})();
